import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from "../../application/ApplicationContext";
import { Space, Table, Button, Input, Spin, Modal, Checkbox } from "antd";
import type { ColumnsType, ColumnType } from "antd/es/table";
import type { InputRef } from "antd";
import type { FilterConfirmProps } from "antd/es/table/interface";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Invoice } from "../../models/Invoice";
import { PdfPreview } from "../../components/PdfPreview/PdfPreview";
import { getInvoiceListReportTemplate } from "../../document-templates/InvoiceListReportTemplate";
import {
  addThousandSeparator,
  formatDate,
  formatTime,
} from "../../core/Utility";
import {
  getAllInvoices,
  updateInvoiceComment,
  updatePaidInvoice,
} from "../../services/InvoiceService";
import { Toast } from "primereact/toast";
import "./InvoiceListPage.scss";
import TextArea from "antd/es/input/TextArea";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import { AxiosResponse } from "axios";
///// REDUX IMPORT
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../store-redux/slices/ChangePageSlice";
import { useLocation } from "react-router-dom";
import { setFiltersInvoice } from "../../store-redux/slices/FiltersInvoiceSlice";
import { setPageItems } from "../../store-redux/slices/ChangeItemsPerPage";

const InvoiceListPage = () => {
  const navigate = useNavigate();
  const { setBreadcrumb } = useApplicationContext();
  const location = useLocation();
  const currentRout = location.pathname;
  const [invoiceList, setInvoiceList] = useState<Invoice[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [activeSpinner, setActiveSpinner] = useState<boolean>(false);
  const searchInput = useRef<InputRef>(null);
  const toast = useRef(null);
  const [showCommentModal, setShowCommentModal] = useState<boolean>(false);
  const [commentText, setCommentText] = useState<string>("");
  const [typeComment, setTypeComment] = useState<
    "dateOfPayment" | "invoiceNumber" | "advanceAccountNumber"
  >();
  const [textModal, setTextModal] = useState<string>("");
  const [invoiceId, setInvoiceId] = useState<string>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [renderPage, setRenderPage] = useState<boolean>(false);
  const [allPaidInvoices, setAllPaidInvoices] = useState<string>("");

  const [allEventOptions, setAllEventOptions] = useState<
    { text: string; value: string }[]
  >([]);
  const [pdfData, setPdfData] = useState<any>(
    getInvoiceListReportTemplate(
      invoiceList,
      `${addThousandSeparator(parseInt(allPaidInvoices ?? "0"))} RSD.`,
    ),
  );

  const downloadPdfDocument = useRef(null);
  const printPdfDocument = useRef(null);

  ///// IMPLEMENTATION REDUX
  const dispatch = useDispatch();
  const currentPage = useSelector((state: any) => state.changePage.currentPage);
  const itemsPerPage = useSelector(
    (state: any) => state.changeItemsPerPage.currentItemsPage,
  );

  const filtersInvoicetState = useSelector(
    (state: any) => state.filterInvoice.filters,
  );

  ///// END IMPLEMENTATION REDUX

  useEffect(() => {
    setBreadcrumb(["Fakture", "Lista profaktura"]);
    fetchAllInvoices();
  }, [currentRout, renderPage]);

  const fetchAllInvoices = () => {
    setActiveSpinner(true);

    let activeIndicator = currentRout === "/invoice-archive" ? false : true;

    getAllInvoices(activeIndicator)
      .then((response) => {
        let data = response.data.result;

        setAllPaidInvoices(response.data.allPaidInvoices?.allPaid);

        data?.map((registration: any) => {
          let country =
            registration?.itemsBillRegistration[0]?.registrations[0]?.country ||
            "Srbija";

          type PriceObj = Record<number, number>;

          let priceObj: PriceObj = {
            32000: 299,
            59000: 520,
            68001: 595,
            108000: 950,
            90000: 798,
            56000: 510,
            71900: 610,
            55500: 470,
            17700: 150,
            8400: 70,
            111000: 940,
            26100: 220,
            ///// SDO 24
            74000: 657,
            65000: 581,
            38000: 352,
            124001: 1100,
            104000: 942,
            68000: 636,
            //// DOT 24
            48500: 440,
            83000: 760,
            14500: 153,
            /// AIDA 25
            75000: 645,
            124000: 1170,
            /// DOT 25
            54500: 466,
            40500: 346,
            95000: 812,
            67000: 572,
            17500: 150,
            /// SDO 25
            44000: 375,
            73000: 625,
            79500: 680,
            84000: 720,
            120000: 1030,
            136000: 1170,
            /// AIDA 26
            77001: 660,
            132000: 1140,
            /// DOT 26
            45500: 387,
            59500: 506,
            77000: 656,
            105000: 894,
            /// SDO 26
            46000: 393,
            86000: 736,
            122000: 1042,
            138000: 1164,
          };

          let currentCurrencyEUR = 117.2; /// - trenutni srednji kurs EUR

          if (country === "Inostranstvo") {
            const sumInEuros = registration.itemsBillRegistration
              .reduce((acc: any, item: any) => {
                const totalPriceInEur = item.price / currentCurrencyEUR;
                return acc + totalPriceInEur;
              }, 0)
              .toFixed(2);

            registration.accommodationPrice = `${registration.itemsBillRegistration.reduce(
              (acc: any, item: any) =>
                priceObj[item.price] ? acc + priceObj[item.price] : sumInEuros,
              0,
            )} Eur.`;
          } else {
            registration.accommodationPrice = `${registration.itemsBillRegistration.reduce(
              (acc: any, item: any) => acc + item.price,
              0,
            )} Din.`;
          }

          return registration;
        }); //// - kad se bude zavrsio dogadjaj, izbrisati MAP - jer cu cene zakucane za ovaj dogadjaj

        let allDataInvoiceWithEvent: any = [];

        data.map((reg: any) => {
          if (reg?.registration) {
            allDataInvoiceWithEvent.push({
              ...reg,
              event: {
                id: reg.registration?.event?.id,
                name: reg.registration?.event?.name,
              },
            });
          } else {
            allDataInvoiceWithEvent.push({
              ...reg,
              event: {
                id: reg.registrationCompany?.event?.id,
                name: reg.registrationCompany?.event?.name,
              },
            });
          }
        });

        setInvoiceList(allDataInvoiceWithEvent);

        setPageNumber(currentPage); /// - SET NUMBER PAGE FROM STORE
        let allEventArr: any = [];

        data.map((reg: any) => {
          if (reg?.registration?.event) {
            allEventArr.push({
              id: reg?.registration?.event?.id,
              text: reg?.registration?.event?.name,
              value: reg?.registration?.event?.name,
            });
          } else {
            allEventArr.push({
              id: reg?.registrationCompany?.event?.id,
              text: reg?.registrationCompany?.event?.name,
              value: reg?.registrationCompany?.event?.name,
            });
          }
        });

        getEventFunc(allEventArr);
      })
      .finally(() => setActiveSpinner(false))
      .catch((err) => console.log(err));
  };

  function getEventFunc(allEvents: any) {
    // Objekat za praćenje jedinstvenih id-jeva
    let currentId: any = {};

    // Niz za čuvanje jedinstvenih događaja
    let currentEvents: any = [];

    // Iteracija kroz objekte
    allEvents.forEach((objekt: any) => {
      let eventId = objekt?.id;

      // Ako id nije definisan ili je već dodat, preskačemo objekat
      if (!eventId || currentId[eventId]) {
        return;
      }

      // Dodajemo id u objekat kako bismo ga označili kao dodat
      currentId[eventId] = true;

      // Dodajemo objekat u rezultujući niz
      currentEvents.push(objekt);
    });

    setAllEventOptions(currentEvents);

    return currentEvents;
  }

  // populate pdf when data changes
  useEffect(() => {
    const newPdf = getInvoiceListReportTemplate(
      invoiceList,
      `${addThousandSeparator(parseInt(allPaidInvoices ?? "0"))} RSD.`,
    );
    setPdfData(newPdf);
  }, [invoiceList, allPaidInvoices]);

  type DataIndex = keyof Invoice;

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<Invoice> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Pretraži`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, border: "none" }}
          >
            Pretraži
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters);
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              close();
              setSearchedColumn("");
            }}
            size="small"
            style={{ width: 90 }}
          >
            Poništi
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#C7363D" : undefined }} />
    ),
    onFilter: (value, record: any) => {
      const recordValue = record[dataIndex];
      if (recordValue === null) {
        return false;
      }
      return recordValue
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase());
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },

    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
            color: "#0D4077",
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const paidInvoiceFunc = (checkedValue: boolean, record: any) => {
    updatePaidInvoice(record?.id, { paid: checkedValue }).then(() => {
      setRenderPage(!renderPage);
    });
  };

  const columns: ColumnsType<Invoice | any> = [
    {
      title: "Broj profakture",
      dataIndex: "sequenceNumber",
      key: "sequenceNumber",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "sequenceNumber" &&
        filtersInvoicetState?.sort?.order,
      filteredValue: filtersInvoicetState?.filters?.sequenceNumber,
      sorter: (a, b) => (a.sequenceNumber < b.sequenceNumber ? -1 : 1),
      //  defaultSortOrder: "ascend",
      render: (sequenceNumber) => (
        <span className="blue-text">{sequenceNumber}</span>
      ),
      ...getColumnSearchProps("sequenceNumber"),
    },
    {
      title: "Datum izdavanja",
      dataIndex: "createdAt",
      key: "createdAt",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "createdAt" &&
        filtersInvoicetState?.sort?.order,
      sorter: (a, b) =>
        new Date(a?.createdAt).getTime() < new Date(b?.createdAt).getTime()
          ? -1
          : 1,
      render: (date) => (
        <span className="blue-text">
          {`${formatDate(new Date(date))} ${formatTime(new Date(date))}h`}
        </span>
      ),
    },
    {
      title: "Poslata profaktura",
      dataIndex: "sentEmail",
      key: "sentEmail",
      render: (sentEmail) => (
        <span className="blue-text">{sentEmail == true ? "Da" : "Ne"}</span>
      ),
    },
    {
      title: "Pravno lice",
      dataIndex: "isCompany",
      key: "isCompany",
      filteredValue: filtersInvoicetState?.filters?.isCompany,
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "isCompany" &&
        filtersInvoicetState?.sort?.order,
      sorter: (a, b) =>
        (a?.isCompany ?? false) < (b?.isCompany ?? false) ? -1 : 1,
      filters: [
        {
          text: "Fizičko lice",
          value: false,
        },
        {
          text: "Pravno lice",
          value: true,
        },
      ], //@ts-ignore
      onFilter: (value: string, record) => record?.isCompany == value,
      render: (isCompany) => (
        <span className="blue-text">{`${isCompany ? "Da" : "Ne"}`}</span>
      ),
    },
    {
      title: "Komitent",
      dataIndex: "clientName",
      key: "clientName",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "clientName" &&
        filtersInvoicetState?.sort?.order,
      filteredValue: filtersInvoicetState?.filters?.clientName,
      sorter: (a, b) => (a.clientName < b.clientName ? -1 : 1),
      render: (clientName) => <span className="blue-text">{clientName}</span>,
      ...getColumnSearchProps("clientName"),
    },
    {
      title: "Događaj",
      dataIndex: "event",
      key: "event",
      filteredValue: filtersInvoicetState?.filters?.event,
      // sorter: (a, b) =>
      //   (a?.event?.name ?? "") < (b?.event?.name ?? "") ? -1 : 1,
      filters: allEventOptions, //@ts-ignore
      onFilter: (value: string, record) => record?.event?.name === value,
      render: (event) => <span className="blue-text">{event?.name}</span>,
    },
    {
      title: "Iznos",
      dataIndex: "totalPrice",
      key: "totalPrice",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey === "totalPrice" &&
        filtersInvoicetState?.sort?.order,
      filteredValue: filtersInvoicetState?.filters?.totalPrice,
      sorter: (a, b) => (a.totalPrice < b.totalPrice ? -1 : 1),
      render: (totalPrice, record: any) => {
        return (
          <span className="blue-text">
            {record?.itemsBillRegistration[0].registrations[0].country}
          </span>
        );
      },
      ...getColumnSearchProps("totalPrice"),
    },
    {
      title: "Email",
      width: 270,
      dataIndex: "email",
      key: "email",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "email" &&
        filtersInvoicetState?.sort?.order,
      filteredValue: filtersInvoicetState?.filters?.email,
      sorter: (a, b) => ((a?.email ?? "") < (b?.email ?? "") ? -1 : 1),
      ...getColumnSearchProps("email"),
      render: (email) => <span className="blue-text">{`${email ?? ""}`}</span>,
    },
    {
      title: "Plaćeno",
      dataIndex: "paid",
      key: "paid",
      //sorter: (a, b) => (a.paid < b.paid ? -1 : 1),
      render: (paid, record: any) => (
        <span
          className="blue-text"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Checkbox
            onChange={(e) => {
              paidInvoiceFunc(e.target.checked, record);
            }}
            className="check-all"
            checked={paid}
          ></Checkbox>
        </span>
      ),
    },
    {
      title: "Datum uplate",
      width: 200,
      dataIndex: "dateOfPayment",
      key: "dateOfPayment",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "dateOfPayment" &&
        filtersInvoicetState?.sort?.order,
      sorter: (a, b) =>
        (a?.dateOfPayment ?? "") < (b?.dateOfPayment ?? "") ? -1 : 1,
      render: (note, data) => (
        <div
          onClick={() => {
            setInvoiceId(data.id as string);
            setCommentText(data.dateOfPayment as string);
            setTypeComment("dateOfPayment");
            setShowCommentModal(true);
            setTextModal("Unesite datum uplate");
          }}
          className="comment-field"
          style={{ cursor: "pointer" }}
        >
          <span className="blue-text">
            {note && note.length >= 35
              ? note.slice(0, 35) + "..."
              : (note ?? "/")}
          </span>
        </div>
      ),
    },
    {
      title: "Broj fakture",
      width: 200,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "invoiceNumber" &&
        filtersInvoicetState?.sort?.order,
      sorter: (a, b) =>
        (a?.invoiceNumber ?? "") < (b?.invoiceNumber ?? "") ? -1 : 1,
      render: (note, data) => (
        <div
          onClick={() => {
            setInvoiceId(data.id as string);
            setCommentText(data.invoiceNumber as string);
            setTypeComment("invoiceNumber");
            setShowCommentModal(true);
            setTextModal("Unesite broj fakture");
          }}
          className="comment-field"
          style={{ cursor: "pointer" }}
        >
          <span className="blue-text">
            {note && note.length >= 35
              ? note.slice(0, 35) + "..."
              : (note ?? "/")}
          </span>
        </div>
      ),
    },
    {
      title: "Br. avanskog računa",
      width: 200,
      dataIndex: "advanceAccountNumber",
      key: "advanceAccountNumber",
      defaultSortOrder:
        filtersInvoicetState?.sort?.columnKey == "advanceAccountNumber" &&
        filtersInvoicetState?.sort?.order,
      sorter: (a, b) =>
        (a?.advanceAccountNumber ?? "") < (b?.advanceAccountNumber ?? "")
          ? -1
          : 1,
      render: (note, data) => (
        <div
          onClick={() => {
            setInvoiceId(data.id as string);
            setCommentText(data.advanceAccountNumber as string);
            setTypeComment("advanceAccountNumber");
            setShowCommentModal(true);
            setTextModal("Unesite broj avanskog računa");
          }}
          className="comment-field"
          style={{ cursor: "pointer" }}
        >
          <span className="blue-text">
            {note && note.length >= 35
              ? note.slice(0, 35) + "..."
              : (note ?? "/")}
          </span>
        </div>
      ),
    },
    {
      title: "Opcije",
      key: "action",
      fixed: "right",
      width: 100,
      align: "center",
      render: (info, record) => (
        <Space size="middle">
          <span
            className="action-button"
            onClick={() => {
              navigate(`/invoice-overview/${info.id}`);
            }}
          >
            Pregled
          </span>
        </Space>
      ),
    },
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const handleComment = (e: any) => {
    setCommentText(e.target.value);
  };

  ////
  const postNewComment = () => {
    updateInvoiceComment(invoiceId, {
      type: typeComment as string,
      text: commentText,
    }).then((res: AxiosResponse) => {
      fetchAllInvoices();
    });
  };

  const handleExcelButton = () => {
    const sortedInvoices = invoiceList.sort((a: Invoice, b: Invoice) => {
      return a.documentId > b.documentId ? -1 : 1;
    });
    const filterObject = sortedInvoices.map((el: any) => {
      return {
        Broj_profakture: el.documentId,
        Datum_izdavanja: `${formatDate(new Date(el.createdAt))} ${formatTime(
          new Date(el.createdAt),
        )}h`,
        Poslata_profaktura: el.sentEmail ? "da" : "ne",
        Pravno_lice: el.isCompany ? "da" : "ne",
        Komitent: el.clientName,
        Događaj: el?.event?.name ?? "",
        Iznos: el.accommodationPrice,
        Email: el.email,
        Plaćeno: el.paid ? "da" : "ne",
        Datum_uplate: el.dateOfPayment ?? "/",
        Broj_fakture: el.invoiceNumber ?? "/",
        Br_avansnog_računa: el.advanceAccountNumber ?? "/",
        Ukupno: "",
      };
    });

    filterObject.unshift({
      Broj_profakture: "",
      Datum_izdavanja: "",
      Poslata_profaktura: "",
      Pravno_lice: "",
      Komitent: "",
      Događaj: "",
      Iznos: "",
      Email: "",
      Plaćeno: "",
      Datum_uplate: "",
      Broj_fakture: "",
      Br_avansnog_računa: "",
      Ukupno: `${addThousandSeparator(parseInt(allPaidInvoices ?? "0"))} RSD.`,
    });

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(filterObject);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "Lista profaktura");
    });
  };

  const saveAsExcelFile = (buffer: any, fileName: string) => {
    import("file-saver").then((module: any) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        module.default.saveAs(
          data,
          fileName +
            "_" +
            formatDate(new Date()) +
            "_" +
            formatTime(new Date()) +
            EXCEL_EXTENSION,
        );
      }
    });
  };

  return (
    <PageLayout>
      <Toast ref={toast} position={"top-right"} />
      <div className="invoice-list">
        <Spin spinning={activeSpinner}>
          <div
            className="legend-row"
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "60px",
              marginTop: "30px",
            }}
          >
            <CustomButton
              danger={false}
              htmlType={"submit"}
              key={2}
              type={"primary"}
              function={() => {
                // setResetData(!resetData);
                // dispatch(resetFiltersParticipant());
                window.location.reload();
              }}
              text={"Resetuj sve filtere"}
              style={{ marginTop: "2rem" }}
            />
          </div>
          <Table
            sticky={true}
            scroll={{ x: 2000 }}
            columns={columns}
            dataSource={invoiceList}
            rowKey={(rowData: any) => rowData.id}
            // pagination={{
            //   defaultPageSize: 30,
            //   showSizeChanger: true,
            //   pageSizeOptions: ["30", "50", "100"],
            // }}
            pagination={{
              current: pageNumber,
              onChange(current) {
                setPageNumber(current);
                dispatch(setCurrentPage(current)); /// DISPATCH ACTION FROM REDUX
              },
              pageSize: itemsPerPage,
              showSizeChanger: true,
              pageSizeOptions: ["30", "50", "100"],
              onShowSizeChange(current, pageSize) {
                dispatch(setPageItems(pageSize));
              },
            }}
            onChange={(pagination, filters, sorter, extra) => {
              dispatch(
                setFiltersInvoice({
                  filters: filters,
                  sort: sorter,
                }),
              );
            }}
            className="table-container"
          />
          <Modal
            maskClosable={false}
            open={showCommentModal}
            title={`${textModal}`}
            onCancel={() => setShowCommentModal(false)}
            onOk={() => setShowCommentModal(false)}
            footer={[
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={1}
                type={"primary"}
                function={() => {
                  postNewComment();
                  setShowCommentModal(false);
                }}
                text={"Potvrdi"}
              />,
              <CustomButton
                danger={false}
                htmlType={"submit"}
                key={2}
                type={"primary"}
                function={() => {
                  setCommentText("");
                  setShowCommentModal(false);
                }}
                text={"Zatvori"}
              />,
            ]}
          >
            <div style={{ padding: "20px 0px" }}>
              <TextArea
                value={commentText}
                onChange={(e) => handleComment(e)}
                rows={4}
                placeholder="Unesite komentar"
              />
            </div>
          </Modal>
        </Spin>
      </div>
      <div className="paid-section">
        <div className="paid-s">
          <p>Ukupno plaćeno:</p>
          <span>
            {addThousandSeparator(parseInt(allPaidInvoices ?? "0"))} RSD.
          </span>
        </div>
      </div>
      <div className="btn-container">
        <div className="footer-btn-container">
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            function={() => {
              handleExcelButton();
            }}
            text={"Excel"}
          />
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            function={() => {
              if (downloadPdfDocument.current) {
                // @ts-ignore
                downloadPdfDocument.current();
              }
            }}
            text={"PDF"}
          />
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            function={() => {
              if (printPdfDocument.current) {
                // @ts-ignore
                printPdfDocument.current();
              }
            }}
            text={"Štampa"}
          />
        </div>
        <div className="document-preview">
          <PdfPreview
            pdfDefinition={pdfData}
            downloadDocument={downloadPdfDocument}
            printDocument={printPdfDocument}
            documentName={`Lista_profaktura_${
              formatDate(new Date()) + "_" + formatTime(new Date())
            }.pdf`}
          />
        </div>
      </div>
    </PageLayout>
  );
};

export default InvoiceListPage;
